import { createTheme } from '@material-ui/core/styles';

//#003F64
//#003F64
//#60C8F4
let theme = createTheme({
  palette: {
    primary: {
      light: '#C7F8FF',
      main: '#0092BC',
      dark: '#348CBA',
    },
    secondary: {
      light: '#ACA9BB',
      main: '#606060',
      dark: '#1E2022',
    },
  },
  typography: {
    fontFamily: ['Helvetica', 'Arial'].join(','),
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});
theme = {
  ...theme,
  overrides: {
    // MuiCssBaseline: {
    //   '@global': {
    //     '@font-face': [Oxygen, Gotham],
    //   },
    // },
    MuiDrawer: {
      paper: {
        backgroundColor: theme.palette.primary.main,
      },
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        margin: '0 16px',
        minWidth: 0,
        padding: 0,
        [theme.breakpoints.up('md')]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    MuiListItemText: {
      primary: {
        //fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
  },
};

export default theme;
